import { usePersonalPlanAvailable } from 'hooks/features/usePersonalPlanAvailable';

export const useShouldDisplayPersonalPlanLink = (): boolean => {
    const isPersonalPlanConfigEnabled =
        import.meta.env.IS_PERSONAL_PLAN && Boolean(JSON.parse(import.meta.env.IS_PERSONAL_PLAN));
    const isFeatureEnabled = usePersonalPlanAvailable();

    return Boolean(isPersonalPlanConfigEnabled && isFeatureEnabled);
};
